export class AdyenError extends Error{
    /**
     * Constructs an AdyenError instance with detailed error information.
     * @param {string} message - The error message describing the issue.
     * @param {number} statusCode - The HTTP status code associated with the error.
     * @param {Error|string} cause - The underlying cause of the error, if any.
     * @param {string} orderNo - The order number related to the error, if applicable.
     */
    constructor(message, statusCode, cause, orderNo) {
        // Pass the message to the native Error class
        super(message)

        // Set the error name for easy identification (e.g., in a catch block)
        this.name = 'AdyenError'

        // Keep the custom properties
        this.statusCode = statusCode
        this.cause = cause
        this.orderNo = orderNo

        // This ensures the constructor is excluded from the stack trace, making it cleaner.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdyenError)
        }
    }
}
